import React, { Component } from "react";
import { Link } from 'react-router-dom'
import * as _ from "lodash";
import API from '../Utils/api'
import * as yup from 'yup'
import { Slide, Snackbar } from "@material-ui/core";
import Cleave from "cleave.js/react"
import "cleave.js/dist/addons/cleave-phone.br"

const schema = yup.object().shape({
    nome: yup
        .string()
        .label('Nome')
        .required('Nome é obrigatório.')
        .trim(),
    sobrenome: yup
        .string()
        .label('Nome')
        .required('Sobrenome é obrigatório.')
        .trim(),
    email: yup
        .string()
        .label('Email')
        .required('Email é obrigatório.')
        .trim()
        .email('Email deve ser válido'),
    senha: yup
        .string()
        .label('Senha')
        .required('Senha é obrigatório.')
        .trim(),

    endereco: yup
        .string()
        .label('Endereço')
        .required('Rua e numero obrigatório.')
        .trim(),
    bairro: yup
        .string()
        .label('Bairro')
        .required('Bairro obrigatório.')
        .trim(),
    cidade: yup
        .string()
        .label('Cidade')
        .required('Cidade obrigatória.')
        .trim(),
    estado: yup
        .string()
        .label('Estado')
        .required('Estado obrigatório.')
        .trim(),

    confirmacaoSenha: yup
        .string()
        .label('Confirmacao')
        .required('Confirmação da senha é obrigatório.')
        .trim()
        .test('is-match', 'Senha e confirmação devem ser iguais', function (value) {
            return value === this.parent.senha
        })
})

const initialState = {
    toggleExpand: false,
    errors: [],
    nome: '',
    sobrenome: '',
    email: '',
    telefone: '',
    senha: '',
    endereco: '',
    bairro: '',
    cidade: '',
    estado: '',
    loggingIn: false,
    confirmacaoSenha: '',
    open: false,
    snackMessage: '',
    severity: 'info',
    // cpf: '',
}


class FormRegistroUsuario extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = async e => {
        e.preventDefault();
        this.setState({ loggingIn: true })



        try {
            await schema.validate(this.state, { abortEarly: false })

            var {
                nome,
                sobrenome,
                email,
                senha,
                telefone,
                endereco,
                bairro,
                cidade,
                estado
            } = this.state;
            const { perfil } = this.props;

            nome += " "+sobrenome;
      

            const registroResponse = await API.post('/api/usuarios', {
                nome, telefone, email, senha, perfil, status: true, endereco, bairro, cidade, estado

            });
            const { error } = registroResponse.data;

            if (error) {
                this.setState({ open: true, errors: [], severity: 'danger', snackMessage: error })
                
            } else {
                // ALTERAR O CONTEÚDO DA snackMessage SE A FUNCIONALIDADE DE ENVIO DE EMAIL FOR ATIVADA
                // EX.: Enviamos um email para que você ative sua conta
                this.setState({
                    ...initialState,
                    open: true,
                    errors: [],
                    severity: 'success',
                    snackMessage: 'Usuário registrado com sucesso.'
                })
            }
        } catch (err) {
            console.log(err)
            if (err.name === 'ValidationError') {
                this.setState(state => {
                    return {
                        ...state,
                        errors: err.inner
                    }
                })
            }
        } finally {
            this.setState({ loggingIn: false })
        }
    };

    hasFormError = (label = '') => {
        const errors = this.state.errors

        if (errors.length > 0) {
            const hasError = errors.filter(item => item.path === label)
            return hasError.length > 0
        }

        return false
    }

    getFormError = (label = '') => {
        const errors = this.state.errors

        if (errors.length > 0) {
            const hasError = errors.filter(item => item.path === label)
            return hasError
        }

        return []
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ open: false })
    }


    render() {
        return (
            <form className="needs-validation" onSubmit={this.handleSubmit} noValidate>

                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    key={'top, center'}
                    style={{ top: '60', minWidth: 340, maxWidth: 640 }}
                    autoHideDuration={2800}
                    TransitionComponent={Slide}
                    open={this.state.open}
                    onClose={this.handleClose}
                >
                    <div className={`alert alert-${this.state.severity} py-3 w-100 col`} role="alert">
                        {this.state.snackMessage}
                        <button type="button" onClick={this.handleClose} className="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </Snackbar>

                <div className="form-group">
                    <label htmlFor="nome">Nome</label>
                    <input id="nome" maxLength="10"  type="text" className={`form-control ${this.hasFormError('nome') && 'is-invalid'}`}
                        name="nome" placeholder="Nome" value={this.state.nome} onChange={this.handleChange} required={true} />
                    <input maxLength="20" id="sobrenome"  placeholder="Sobrenome"  type="text" className={`mt-3 form-control ${this.hasFormError('sobrenome') && 'is-invalid'}`}
                        name="sobrenome" value={this.state.sobrenome} onChange={this.handleChange} required={true} />
                    <div className="invalid-feedback">
                        {this.getFormError('nome').map(item => item.message)}
                    </div>


                    
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input id="email" type="email"
                        className={`form-control ${this.hasFormError('email') && 'is-invalid'}`}
                        name="email" value={this.state.email} onChange={this.handleChange} required={true} />
                    <div className="invalid-feedback">
                        {this.getFormError('email').map(item => item.message)}
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="telefone">Whatsapp</label>
                    {/* <input id="telefone" type="telefone"
                           className={`form-control ${this.hasFormError('telefone') && 'is-invalid'}`}
                           name="telefone" value={this.state.telefone}  required={true}/> */}



                    <Cleave name="telefone"
                        placeholder="99 99999 9999"
                        data-length="10"
                        value={this.state.telefone || ''}
                        className={`form-control ${this.hasFormError('telefone') && 'is-invalid'}`}
                        options={{
                            phone: true,
                            phoneRegionCode: 'BR'
                        }}
                        onChange={this.handleChange}
                    />

                    <div className="invalid-feedback">
                        {this.getFormError('telefone').map(item => item.message)}
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="endereco">Rua/Numero</label>
                    <input id="endereco" type="text" className={`form-control ${this.hasFormError('endereco') && 'is-invalid'}`}
                        name="endereco" value={this.state.endereco} onChange={this.handleChange} required={true} />
                    <div className="invalid-feedback">
                        {this.getFormError('endereco').map(item => item.message)}
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="bairro">Bairro</label>
                    <input id="bairro" type="text" className={`form-control ${this.hasFormError('bairro') && 'is-invalid'}`}
                        name="bairro" value={this.state.bairro} onChange={this.handleChange} required={true} />
                    <div className="invalid-feedback">
                        {this.getFormError('bairro').map(item => item.message)}
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="cidade">Cidade</label>
                    <input id="cidade" type="text" className={`form-control ${this.hasFormError('cidade') && 'is-invalid'}`}
                        name="cidade" value={this.state.cidade} onChange={this.handleChange} required={true} />
                    <div className="invalid-feedback">
                        {this.getFormError('cidade').map(item => item.message)}
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="estado">Estado</label>
                    {/* <input id="estado" type="text" className={`form-control ${this.hasFormError('estado') && 'is-invalid'}`}
                        name="estado" value={this.state.estado} onChange={this.handleChange} required={true} /> */}

                    <select id="estado" type="text" className={`form-control ${this.hasFormError('estado') && 'is-invalid'}`}
                        name="estado" onChange={this.handleChange} required={true}>
                        <option value='' defaultValue>Escolha...</option>
                        <option value="AC">Acre</option>
                        <option value="AL">Alagoas</option>
                        <option value="AP">Amapá</option>
                        <option value="AM">Amazonas</option>
                        <option value="BA">Bahia</option>
                        <option value="CE">Ceará</option>
                        <option value="DF">Distrito Federal</option>
                        <option value="ES">Espírito Santo</option>
                        <option value="GO">Goiás</option>
                        <option value="MA">Maranhão</option>
                        <option value="MT">Mato Grosso</option>
                        <option value="MS">Mato Grosso do Sul</option>
                        <option value="MG">Minas Gerais</option>
                        <option value="PA">Pará</option>
                        <option value="PB">Paraíba</option>
                        <option value="PR">Paraná</option>
                        <option value="PE">Pernambuco</option>
                        <option value="PI">Piauí</option>
                        <option value="RJ">Rio de Janeiro</option>
                        <option value="RN">Rio Grande do Norte</option>
                        <option value="RS">Rio Grande do Sul</option>
                        <option value="RO">Rondônia</option>
                        <option value="RR">Roraima</option>
                        <option value="SC">Santa Catarina</option>
                        <option value="SP">São Paulo</option>
                        <option value="SE">Sergipe</option>
                        <option value="TO">Tocantins</option>
                    </select>
                    <div className="invalid-feedback">
                        {this.getFormError('estado').map(item => item.message)}
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="senha">Senha</label>
                    <input id="senha" type="password"
                        className={`form-control ${this.hasFormError('senha') && 'is-invalid'}`}
                        name="senha" value={this.state.senha} onChange={this.handleChange} required={true} />
                    <div className="invalid-feedback">
                        {this.getFormError('senha').map(item => item.message)}
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="confirmacao-senha">Confirme a senha</label>
                    <input id="confirmacao-senha" type="password"
                        className={`form-control ${this.hasFormError('confirmacaoSenha') && 'is-invalid'}`}
                        name="confirmacaoSenha" value={this.state.confirmacaoSenha} onChange={this.handleChange}
                        required={true} />
                    <div className="invalid-feedback">
                        {this.getFormError('confirmacaoSenha').map(item => item.message)}
                    </div>
                </div>
                <div className="clearfix">
                    <button disabled={this.state.loggingIn} className="btn btn-warning bg-warning text-dark float-lg-right"
                        type="submit">{this.props.submitLabel}</button>
                </div>
                <p className="mt-4 text-center" style={{ fontSize: '14px' }}>Já tem uma conta?
                    <Link to="/login"> Entrar</Link>
                </p>
            </form>
        )
    }
}

export default FormRegistroUsuario;